<style scoped>
  .upload-input-btn {
    font-size: 14px;
    padding: 6px 12px;
    border-radius: 3px;
    color: #fff;
    background-color: #409eff;
    border-color: #409eff;
    cursor: pointer;
  }

  .upload-input {
    display: none;
  }
</style>

<script type="text/jsx">
  import http from './xhr';
  import UploadList from './UploadList.vue'

  export default {
    data() {
      return {
        reqs: null,
        fileMap: this.fileList
      }
    },
    components: {
      UploadList
    },
    props: {
      type: String,
      action: {
        type: String,
        required: true
      },
      name: {
        type: String,
        default: 'file'
      },
      data: Object,
      headers: Object,
      withCredentials: Boolean,
      multiple: Boolean,
      accept: String,
      onStart: Function,
      onSuccess: {
        type: Function,
        default: function() {
        }
      },
      onError: {
        type: Function,
        default: function() {
        }
      },
      beforeUpload: Function,
      drag: Boolean,
      onPreview: {
        type: Function,
        default: function() {
        }
      },
      onRemove: {
        type: Function,
        default: function() {
        }
      },
      fileList: Array,
      autoUpload: Boolean,
      listType: String,
      httpRequest: {
        type: Function,
        default: http
      },
      disabled: Boolean,
      limit: Number,
      onExceed: Function,
      handleDelete: Function
    },
    methods: {
      handleChange(e) {
        const files = e.target.files;
        if(!files) return;
        this.uploadFiles(files);
      },
      uploadFiles(files) {
        let postFiles = Array.prototype.slice.call(files);
        if(!this.multiple) { postFiles = postFiles.slice(0, 1); }
        if(postFiles.length === 0) return;

        const l = Object.keys(this.fileMap).length, f = l === 0;
        postFiles.forEach((rawFile, index) => {
          this.$set(this.fileMap, index + l, {
            name: rawFile.name,
            file: rawFile,
            percentage: 0
          });
          // this.onStart(rawFile);
          this.upload(rawFile, index + l);
        });

      },
      upload(rawFile, index) {
        this.$refs.input.value = null;
        if(!this.beforeUpload) {
          return this.post(rawFile, index);
        }
        const before = this.beforeUpload(rawFile);
        if(before) {
          this.post(rawFile, index, before);
        }

      },
      post(rawFile, index, before) {
        let o = null;
        ({}).toString.call(before) === '[object Object]' ?  o = before : null;
        const options = {
          headers: this.headers,
          withCredentials: this.withCredentials,
          file: rawFile,
          data: o? o :this.data,
          filename: rawFile.name,
          action: this.action,
          onProgress: e => {
            this.onProgress(e, index);
          },
          onSuccess: res => {
            this.onSuccess(res, rawFile);
          },
          onError: err => {
            this.onError(err, rawFile);
          }
        };

        this.httpRequest(options);
      },
      onProgress(e, index) {
        this.$set(this.fileMap[index], 'percentage', e.percent)
      },
      handleClick(e) {
        if(!this.disabled) {
          this.$refs.input.value = null;
          this.$refs.input.click();
        }
      },
      handleDeleteFile(name, index) {
        this.handleDelete(this.fileMap[index], index)
      },
      deleteFile(index) {
        delete  this.fileMap[index]
      }
    },
    render(h) {
      const FormData = !!window.FormData;
      const data = {
        on: {
          click: this.handleClick
        }
      };

      return (
        <div>
          <button type="button" {...data} class="upload-input-btn">
            <span>点击上传</span>
            {
              FormData ?
                <input
                  class="upload-input"
                  type="file"
                  ref="input"
                  name={this.name}
                  on-change={this.handleChange}
                  multiple={this.multiple}
                  accept={this.accept}
                ></input> :
                '浏览器支持 FormData'
            }
          </button>
          <UploadList delete={this.handleDeleteFile} ref="uploadList" fileList={this.fileMap}/>
        </div>


      )
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Upload/Upload.vue